import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "header-breadcrumb m-0 flex min-h-9 list-none items-center gap-2 overflow-hidden p-0",
    ref: "breadcrumbs"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        ($setup.shouldAddDefaultBreadcrumb)
            ? (_openBlock(), _createBlock($setup["EnBreadcrumbItem"], {
                key: 0,
                breadcrumb: $setup.defaultBreadcrumb
            }, null, 8 /* PROPS */, ["breadcrumb"]))
            : _createCommentVNode("v-if", true),
        _renderSlot(_ctx.$slots, "breadcrumbs")
    ], 512 /* NEED_PATCH */));
}
